import { useEffect, useState } from "react"
import { useLocation,useNavigate, Link } from "react-router-dom"
import _axios from "../axios"
import buildLink from "../urls"
import Catalogv2 from "./Catalogv2"
import notFound from "../assets/images/page-404.webp";
import { useWindowDimensions } from "../components/TopHeader"
import CatalogPlaceholder from "./CatalogPlaceholder"
import { path } from "../urls"
import CatalogMobilePlaceholder from "../components/CatalogMobilePlaceholder"
import Productv2 from "./Productv2"
function Anything() {

    const [aliasId,setAliadId] = useState()
    const { width } = useWindowDimensions();
    const [aliasName,setAliasName] = useState()
    const location = useLocation()
    const history  = useNavigate()
    const [loading,setLoading] = useState(true)
    const path1 = location.pathname.slice(1,location.pathname.length)
    async function getAlias(){
        const alias = await _axios.get(buildLink(`alias`,undefined, window.innerWidth) + path1)
        if(alias.data.query !== undefined){
                const theAlias = alias.data.query.split("=",2)
                 setAliasName(theAlias[0].split('_',1)[0])
                 setAliadId(theAlias[1])
                
                //  data = await axios.get(buildLink(aliasName,undefined,))
        }
        setLoading(false)
    }
    useEffect(() => {
        getAlias()
    },[path1])
if(aliasId && aliasName !=='product'){
    return (
        <div className="h-full">
        {aliasId && 
            <Catalogv2 id={aliasId} type={aliasName} />
        }
        </div>
    )
}

if(aliasId && aliasName==='product'){
  return (
      <div className="h-full">
      {aliasId && 
          <Productv2 id={aliasId} />
      }
      </div>
  )
}
if(loading){
    return (
        width > 650 ? (
            <CatalogPlaceholder style={ "hidden"} />
          ) : (
            <CatalogMobilePlaceholder style={"hidden"} />
          )
    )
}
return (
    <div className="flex items-center justify-center mt-20 pb-5 flex-col">
      <img src={notFound} className=" w-2/12" alt="Not Found" />
      <h2 className="text-2xl mt-4">Sorry, there is nothing here!</h2>
      <Link
        to={`${path}/`}
        className="bg-dblue text-white px-10 py-3 rounded mt-4"
      >
        START SHOPPING
      </Link>
      <button
        onClick={() => history.goBack()}
        className="bg-dbase text-white px-10 py-3 rounded mt-4"
      >
        Go back
      </button>
    </div>
  );
}

export default Anything
